import { UPDATE_SUPPLIER } from './types';

export const updateSupplier = (supplier) => {
	return async (dispatch, getState) => {
		dispatch({ type: UPDATE_SUPPLIER, payload: supplier });
	};
};